module.exports = __webpack_public_path__ + "static/media/invoices.ce7e159d.svg";